<template>
  <div>
      <div class="goodslistpage">
          <div class="contents">
            <goods-list-title :classname="classname" />
            <div>
                <goods-list-left ref="goodswhere" />
                <goods-list-right  @getGoodsWhere="getGoodsWhere" />
                <div class="clear"></div>
            </div>
          </div>
      </div>
      <comparison />
  </div>
</template>
<script>
  import GoodsListLeft from '../../components/goods/GoodsListLeft.vue'
  import GoodsListRight from '../../components/goods/GoodsListRight.vue'
  import GoodsListTitle from '../../components/goods/GoodsListTitle.vue'
  import Comparison from '../../components/goods/Comparison.vue'
  export default {
    components: { GoodsListTitle, GoodsListLeft, GoodsListRight, Comparison },
    data() {
      return {
        pid:"",
        classname:"",
        classid:""      
      }
    },
    metaInfo() {
    return {
      title: "Movibot官网_工业机器人上下游供应链",
      meta: [
        {
          name: "keywords",
          content:
            "工业机器人_工业机器人上下游供应链_工业机器人品牌_工业自动化设备_行业解决方案",
        },
        {
          name: "description",
          content:
            "Movibot汇聚中国工业机器人上下游供应链优质工业机器人品牌,为工业机器人,智能家庭及商业应用,仓储物流,食品行业,医药行业,汽车行业,机械设备制造,电子行业提供工业自动化设备和行业解决方案",
        },
      ],
    };
  },
    methods:{
      getGoodsWhere(){
        return this.$refs.goodswhere.conditions();
      }
    },
    watch: {
            '$route' (to, from) { //监听URL地址栏参数变化
                this.classname = this.$route.params.classname;
                this.pid = this.$route.params.pid;
                this.classid = this.$route.params.classid;
                this.$refs.goodswhere.reset();
                this.$refs.goodswhere.getclasslist(this.pid);
                
              }
    },
    mounted(){
      this.classname = this.$route.params.classname;
      this.pid = this.$route.params.pid;
      this.classid = this.$route.params.classid;

            // var goodsid = this.$route.params.goodsid;
            // this.getinfo(goodsid);
    },
    created(){
            //this.pid = this.$route.params.classid;
            // var goodsid = this.$route.params.goodsid;
            // this.getinfo(goodsid);
            // 进入列表页时先清空 Vuex 中上一次残留的筛选条件，避免旧的 classid (cid2) 被带到接口；
            // 放在 created 阶段处理，此时子组件尚未挂载，不会触发 getGoodsWhere watcher 造成重复请求
            this.$store.commit('saveGoodsWhere', []);
    },
  }
  //this.$route.params.id
  

</script>
<style>
  .goodslistpage{
    background-color: #f3f5f7;
    /* overflow: hidden; */
  }
    
</style>


// WEBPACK FOOTER //
// src/views/goods/list.vue